import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';
import { Link } from 'react-router-dom';

const BusinessDomains = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Business Domains"
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                    />
                    <div class="inner-container">
                        <h2>Business Domains</h2>
                        <h3>
                            <Link to="/services/business-domains/healthcare-it">Healthcare IT</Link>
                        </h3>
                        <p>We build our solutions around your practice. Our solutions would cover every aspect of your practice, be it diagnostics, patient care, or administration. Unify all roles of your practise to improve clinical care</p>
                        <h3>
                            <Link to="/services/business-domains/information-technology">Information Technology</Link>
                        </h3>
                        <p>It’s your idea and we help you do more of it. We speak your language and turn your ideas into ground breaking business solutions.</p>
                        <h3>
                            <Link to="/services/business-domains/e-commerce">E Commerce</Link>
                        </h3>
                        <p>Build, transform, and optimize. End goal of any business domain is to maximize profit while streamlining its operations. Be it a new one or updating an already existing e-shop we do it that too as per your requirements.</p>
                        <h3>
                            <Link to="/services/business-domains/elearning">eLearning</Link>
                        </h3>
                        <p>Solutions should not only solve problems but add value to the environment in which the solution is offered.</p>
                        <p>We just don’t create eLearning tools, but offer you an incredible learning experience. Our eLearning solutions involves a classroom blended virtual delivery mode of approach</p>
                        <h3>
                            <Link to="/services/business-domains/retail-software-system">Retail Software System</Link>
                        </h3>
                        <p>Our retail management software would help you sell in store, online, at marketplaces, and on the go. You can manage all aspects of your business with this easy to use system. Add warehouses, outlets, new locations at the click of the button.</p>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default BusinessDomains;